module.exports = __webpack_public_path__ + "img/F5-3B.bd3b6709.png";